var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#0096D6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7093 11.8812L8.75036 5.92223L5.41391 5.41421L5.92193 8.75066L11.8808 14.7096M14.7093 11.8812L11.8808 14.7096M14.7093 11.8812L15.4301 12.602C17.1601 14.332 14.3317 17.1604 12.6017 15.4304L11.8808 14.7096",
    stroke: "white",
    strokeWidth: 0.70354
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.20d4d2a01d8680ccc60f6e6ca868b349.svg";
export { ForwardRef as ReactComponent };